module.exports = __webpack_public_path__ + "static/media/darkmode.1466f4c0.png";